"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRectangleLength = getRectangleLength;
function getRectangleLength(rect) {
    return Math.sqrt(Math.pow(rect.x2 - rect.x1, 2) + Math.pow(rect.y2 - rect.y1, 2));
}
//# sourceMappingURL=IRectangle.js.map